import react, { useEffect, useState } from 'react';
import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { getParentFaq } from '../../app/api';
import { useTranslation } from 'react-i18next';
import FloatingShapes from "../common/FloatingShapes";


// const faqs = [
//   {
//     title: "Манай цогцолборт амрах хугацаандаа:",
//     question: "Амрагч хүүхдийн мөрдөх журам",
//     answer:
//       `Амралтын хугацаанд  өөрт тань тааламжгүй, ойлгомжгүй асуудал гарвал хамгийн түрүүнд бүлгийн удирдагчдаа хэлж, яаралтай арга хэмжээ авахуулна.
//       /Амралтын бүсэд байгаа болон бий болсон орчны аюулгүй байдалд өөрийн зүгээс хянамгай байж, аливаа осол гэмтлээс урьдчилан сэргийлнэ.
//       /Амарч байх хугацаанд биед гарсан эрүүл мэндийн аливаа өөрчлөлтийг цаг алдалгүй бүлгийн удирдагчдаа мэдэгдэж, яаралтай тусламж авна.
//       /Нэг бүлэг, өрөөнд амарч буй найз нөхөд, ах эгч, дүү нараа хүндэлж,  харилцааны эерэг уур амьсгалыг эрхэмлэнэ.
//       /Бусад амрагчдад тулгарсан асуудлыг эерэгээр шийдвэрлэх алхамыг хийж, тэдэнтэй найзалж, нөхөрлөн шаардлагатай үед нь тусална.
//       /Зуслангийн өдрийн дэглэм, хөгжлийн хөтөлбөрт оролцохдоо  хувийн соёл, цаг баримтлалийг өөртөө хэвшүүлж, идэвхи санаачилгатай байна.
//       /Зуслангийн ажилтан, албан хаагчдын хөдөлмөрийг хүндэлж, ойлгомжгүй зүйлээ асууж тодруулна.
//       /Нэгдсэн менежементийн тогтолцоог хэрэгжүүлж буй манай Цогцолборын байгалийн баялаг болсон ургамал, амьтан ногоон байгууламжид хайр гамтай хандана.
//       /Манай зусланд интернэтийн хэрэглээг хязгаарладаг тул гар утасны хэрэглээндээ анхаарна.
//       /QR код бүхий эрхийн бичгээ сайтар хямгадаж, гээгдүүлэхгүй байхад анхаарна.
//       `,
//   },
//   {
//     title:
//       "Эрүүл мэндийн хуудсыг татан авч эх хүүхдийн эрүүл мэндийн үндэсний төвийн Зүүн талаас (зурагт) хашаагаар ороод 2 давхар Үргүйдэл нөхөн үржихүйн төвийн байранд заавал шинжилгээ хийлгэж тэмдэглүүлнэ.",
//     question: "Эрүүл мэндийн үзлэг",
//     link: true,
//     answer:
//       "Хүүхдийн эмчид үзүүлэх /  Арьс өнгөний үзлэг /  Шимэгч хорхойн шинжилгээ / Шээсний шинжилгээ",
//     data: "Ээлжийн эхний өдөр "Найрамдал" цогцолборын эмчийн урьдчилан сэргийлэх үзлэгээр тэнцээгүй/ шинжилгээ хийлгээгүй, эмчилгээ шаардлагатай өвчлөл илэрсэн/ хүүхдийг өдөрт нь эцэг эхэд нь мэдэгдэж, "Гараас гарт" буцаахыг анхаарна уу.",
//   },
//   {
//     title: "",
//     question: "Зусланд юу авч явах вэ?",
//     answer:
//       `Өндөр үнэ өртөгтэй  алт үнэт эдлэл, гар утас, видео камер, гэрэл зургийн аппарат, ганган чамин хувцас, хэрэглэл амралтын хугацаанд төдийлөн хэрэглэгддэггүй тул шаардлагагүй, авч ирсэн бол бүлгийн удирдагчийн бүртгэлд бүртгүүлж, өөрөө хариуцлага хүлээнэ.
//       /Манай цогцолборт тусгай дүрэмт хувцас өмсөх шаардлагагүй, гэхдээ хөгжлийн хөтөлбөрийн үйл ажиллагаа байнгын хөдөлгөөн, өөрийн оролцоог эрхэмлэж, өдрийн турш идэвхитэй байдаг тул дотор болон гадаа өмсөх биед эвтэйхэн нимгэн зөөлөн, дулаан хувцас (хүрэм, ноосон цамц, ємд, борооны цув, бусад) хэрэгтэй. Мөн өөрийн хувцсандаа гамтай байж, гээхгүй, орхихгүй байхад анхаарна.
//       /Ариун цэврийн хэрэглэл (шүдний оо, сойз, гар нүүрийн алчуур шампунь сам , бусад), өрөөний болон усны шаахай, зэргийг бэлтгэж ирнэ.
//       /Амны хаалт, гар ариутгагч заавал хэрэгтэй.
//       /Өөрийн биеийн эрүүл мэнддээ анхаарч тогтмол хэрэглэдэг эм байвал эцэг эхийн зөвшөөрлөөр авч ирж, эмчид мэдэгдэн тогтмол хэрэглэхийг мартуузай.
//       /Хүүхэд бүр өөрийн усны савтай ирнэ.
//       /Өөрийн заавал хэрэглэгдэг хүнсний нэмэлт бүтээгдэхүүнийг авч ирж болох ч, бэлэн гоймон, хийтэй ундаа, мах махан бүтээгдэхүүн, лаазалсан болон амархан мууддаг жимс жимсгэнэ, өндөг, хайлж урсдаг чихэр түүнтэй адилтгах зүйлийг хориглодог тул анхааралтай хандана уу.
//       `,
//   },
//   {
//     title: "",
//     question: "Манай цогцолборт амрах хуацаанд хориглох зүйлс:",
//     answer:
//       `Тэжээвэр амьтан авч ирэхийг
//       /Гал асаагуур, лаа, үсний индүү, үсний сэнс, халаагуур авч ирэхийг
//       /Бүх төрлийн тоглоомон буу (усан буу, үрлэн сумтай буу)-тай ирэхийг
//       /Хурц иртэй, хайч, хутга, үзүүртэй зүйлс, цаасны хутгатай байхыг
//       /Найрлага нь тодорхой бус бодис, эм, тариа авч ирэхийг
//       /Архи согтууруулах ундааны төрөл, утаат болон цахилгаан тамхитай байхыг
//       /Үнэтэй эд эдлэл (дрон, зургийн аппарат, их хэмжээний бэлэн мөнгө, зөөврийн таблет эсвэл компьютер)-тэй байхыг
//       /Лазераар заагч гэрэл ав ирэхийг
//       /Хог хаягдлыг ил задгай хаяхыг
//       /Ой мод, аж ахуйн бүс, өөрийн бүлгээс бусад хэсэг рүү бүлгийн удирдагчийн зөвшөөрөлгүй явахыг
//       /Хурдан муудах хүнсний бүтээгдэхүүн (мах махан бүтээгдэхүүн, лаазалсан бүтээгдэхүүн, өндөгний орцтой бүтээгдэхүүн) авч ирэхийг
//       `,
//   },
// ];

const faqsEnd = [
  {
    question: "Автобусны аюулгүй байдлын дүрэм юу вэ?",
    answer: `Суудлын бүсийг заавал зүүх Автобус хөдлөх үед босохгүй байх Автобусанд юм идэх хориотой Суудал дээрээс эргэж харах, босож зогсох, үсрэхгүй байх  Бүлгийн удирдагчийн заавар зөвлөгөөг биелүүлэх`,
  },
  {
    question: "Хоцорсон үед яах вэ?",
    answer:
      "Ээлжийн цуваанаас хоцорсон тохиолдолд эцэг эхчүүд болон асран хамгаалагч нь цогцолборын байранд хүргэж өгөх асуудлыг бүрэн хариуцна. Амрагч хүүхдийн овог нэр, нас, хүйс, холбоо барих дугаар, цогцолборт ирэх цаг зэргийг тухайн өдрийн 12.00 цагаас өмнө 75056010  дугаарын (Амралтын төв байр)-тай холбогдон тэмдэглүүлнэ. Заасан хугацаанд дээрх мэдээллийг ирүүлээгүй тохиолдолд бүлэг хувиарлалтаас хоцрох тул хариуцлагатай хандахыг хүсч байна.",
  },
  {
    question: "Эргэлт хийх бол яах вэ?",
    answer:
      "Зуслан нь хүүхдийн бие даах чадвар нэмэгдүүлэх зорилготой орчин учраас \u201cЭРГЭЛТ\u201d үйл ажиллагааг зохион байгуулахгүйг анхаарна уу.",
  },
  {
    question: "Бүлгийн мэдээлэл хэрхэн авах вэ?",
    answer:
      "Та хүүхдээ аль бүлэгт орсон, бүлгийн удирдагчтай холбогдох тохиолдолд тухайн ээлж эхэлсэн өдрийн 14,00 цагаас хойш 75056010 дугаарт (Амралтын төв байр) холбогдон хүүхдийнхээ овог, нэр, сургуулийг хэлж ямар бүлэгт хувиарлагдсаныг мэдэж болно.",
  },
];

interface FaqItem {
  title: string;
  content: string;
}

export default function Parent() {
  const { t } = useTranslation();
  const [faqs, setFaqs] = useState<FaqItem[]>([]);


  useEffect(() => {
    getParentFaq()
      .then((res) => {
        setFaqs(res.data as FaqItem[]);
      })
      .catch((err) => console.error('Failed to load FAQs:', err))
  }, []);

  return (
    <>
      {/* Dark Hero Header */}
      <div className="relative overflow-hidden bg-primary-800 -mt-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-warm-500/15 blur-[120px]" />
          <div className="absolute top-1/2 -left-40 w-[400px] h-[400px] rounded-full bg-secondary-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="default" />
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
        <div className="relative pt-40 pb-16 sm:pt-48 sm:pb-20">
          <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-warm-300 backdrop-blur-sm">
              <span className="inline-block w-1.5 h-1.5 rounded-full bg-warm-400 animate-pulse" />
              {t('parent.badge')}
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white tracking-tight">
              {t('parent.title')}
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-slate-400 max-w-3xl mx-auto">
              {t('parent.subtitle')}
            </p>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <Disclosure
                  as="div"
                  key={index}
                  className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 animate-slide-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-between p-6 text-left">
                        <span className="text-lg font-bold leading-7 text-neutral-900 flex items-center gap-3">
                          {faq.title}
                        </span>
                        <span className="ml-6 flex h-10 w-10 items-center justify-center rounded-xl bg-warm-600 text-white shadow-md">
                          {open ? (
                            <MinusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          ) : (
                            <PlusSmallIcon className="h-6 w-6" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                      <Disclosure.Panel as="div" className="px-6 pb-6">
                        <div
                          className="text-base leading-7 text-neutral-600 bg-warm-50 rounded-xl p-6 [&>ul]:list-disc [&>ul]:pl-6 [&>ul>li]:mb-2"
                          dangerouslySetInnerHTML={{ __html: faq.content }}
                        />
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Common FAQs - Dark Section */}
      <div className="relative overflow-hidden bg-primary-800 py-16 sm:py-20">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-warm-500/15 blur-[120px]" />
          <div className="absolute bottom-0 -left-40 w-[400px] h-[400px] rounded-full bg-warm-500/10 blur-[100px]" />
        </div>
        <FloatingShapes variant="alt" />
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: '60px 60px' }} />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="section-header text-3xl sm:text-4xl font-bold text-white mb-4">
              {t('parent.commonFaqTitle')}
            </h2>
          </div>
          <div className="grid lg:grid-cols-2 gap-8">
            {faqsEnd.map((faq, index) => {
              const numGradient = ['from-warm-500 to-warm-600', 'from-secondary-500 to-secondary-600'][index % 2];
              return (
              <div
                key={faq.question}
                className="bg-white/5 border border-white/10 backdrop-blur-sm rounded-2xl p-6 hover:bg-white/10 transform hover:-translate-y-1 transition-all duration-300 animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="flex items-start gap-4">
                  <div className={`flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br ${numGradient} flex items-center justify-center shadow-md`}>
                    <span className="text-white font-bold text-sm">{String(index + 1).padStart(2, '0')}</span>
                  </div>
                  <div className="flex-1">
                    <dt className="text-lg font-bold leading-7 text-white mb-3">
                      {faq.question}
                    </dt>
                    <dd className="text-base leading-7 text-slate-400">
                      {faq.answer}
                    </dd>
                  </div>
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
